<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				size='mini'
				border
				stripe
				:height="tableHeight"
				@selection-change="selectionChangeHandle"
			>
				<el-table-column
					type="selection"
					align="center"
					width="55">
								</el-table-column>
								<el-table-column
					prop="name"
					label="店铺名称"
					align="center"
					min-width="180">
				</el-table-column>
								<el-table-column
					prop="code"
					label="店铺编号"
					align="center"
					min-width="180">
				</el-table-column>
								<el-table-column
					prop="date"
					label="关联时间"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center" v-if="editDisable">
					<template slot-scope="scope">
						<el-button type='text' size="mini" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20,40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		editDisable: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: 1,
				size: 20
			}
		}
	},
	methods: {
		selectionChangeHandle (value) {
			let ids = value.map((item) => {
				return item.id
			})
			this.$emit('delStoreMore', ids)
		},
		handleSizeChange (value) {
			this.$emit('sizeChange', value)
		},
		handlePageChange (value) {
			this.$emit('pageChange', value)
		},
		del (value) {
			this.$confirm('是否删除关联的门店？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.$emit('delStore', value.id)
			}).catch(() => {})
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	max-width: 1200px
	flex-direction: column
	height: 100%
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
	}
}
</style>
